"use client";

import { TCircleIconButton } from "../../types/types";

function resolveAriaLabel(customClass?: string, ariaLabel?: string): string {
	if (ariaLabel) return ariaLabel;

	const classes = customClass ?? "";
	if (classes.includes("swiper-full-prev") || classes.includes("swiper-prev") || classes.includes("rotate-180") || classes.includes("scale-x-[-1]")) {
		return "Previous slide";
	}
	if (classes.includes("swiper-full-next") || classes.includes("swiper-next")) {
		return "Next slide";
	}

	return "Button";
}

const CircleIconButton: React.FC<TCircleIconButton> = ({
  icon,
  action,
  customClass,
  style,
  disabled,
  ariaLabel,
}) => {

  const styles = {
    grey: "bg-oBlack-10 hover:bg-oBlack-20 focus:bg-oBlack-30 active:bg-oBlack-30",
    white:
      "bg-OWhite-10 hover:bg-oWhite-20 focus:bg-oWhite-30 active:bg-oWhite-30",
  };

  return (
    <button
      type="button"
      aria-label={resolveAriaLabel(customClass, ariaLabel)}
      className={` circleIconButton flex items-center justify-center backdrop-blur-32px w-11 h-11 rounded-full linear-gradient-border-circle ${styles[style || "grey"]} ${customClass || ""} ${disabled ? "disabled":""} `}
      onClick={action}
      disabled={disabled}
    >
      <span className="icon" aria-hidden="true">{icon}</span>
    </button>
  );
};

export default CircleIconButton;
